import React, {useEffect, useRef, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import InputField from "../../base-components/base-input";


const LegalAddressStep = ({_step_service, next_step, step_ID, step_URL, step_form, error, getDataFromContext, setDataToContext, max, getStep}) => {
    const [isValid, setIsValid] = useState(false)
    const form = useRef()

    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [nextTick, setNextTick]= useState(false)
    const mock_error = []
    const [cityIsChoosen, setCityIsChoosen] = useState(data?.__postal_input !== "NULL (NULL)")

    const getInputValue = (name, value) => {
        // if (value.length > 0) {
             setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)
        // }
       
    }

    const _error = error.length > 0 || mock_error
    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {

        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:home address",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             }
            );
        }

        // getStep(["street", "house_number", "box", "zip_code", "city"]).then(res => {
        //     // res["__postal-input"] = `${res.city} (${res.zip_code})`
        //     console.log("res => ", res)
        //     setInputData({ ...res })
            setNextTick(true)
        // })
    }, [])

    useEffect(() => {
        if (nextTick) {
            setInputData({ ...inputData, "__postal-input" : `${inputData.city} (${inputData.zip_code})` })
        }
    }, [nextTick])

    const isValidForm = () => {
        const arr = [...form.current.elements].filter(element => (element.name !== "streetBox"))
        return (arr.filter(ar => ar.id !== "box")).every(element => {
            return element.value !== "" && element.value !== " " && cityIsChoosen
        })
    }

    const getPostalValidity = (bool) => {
        setCityIsChoosen(bool)
    }
    return (
        <>
            <StepsLoader loading={isLoading}>
                <form ref={form}>
                <BaseParagraph>
                    <h3>{t('personal_infos.Personal_info_address.title')}</h3>
                </BaseParagraph>

                {step_form.map(input => (
                    <InputField
                        type={input.type}
                        label={t(input.label)}
                        value={inputData[input.id] !== "NULL" && inputData[input.id]}
                        name={input.id}
                        getInputValue={getInputValue}
                        key={input.id}
                        error={_error}
                        max={input.max}
                        getPostalValidity={getPostalValidity}

                    />))}
                </form>
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} />

            </StepsLoader>

        </>
    )
}

LegalAddressStep.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}



export default LegalAddressStep